import { createSelector } from '@reduxjs/toolkit'
import { timeScheduleSlice } from '..'

export const serviceAmountSelector = createSelector(
  [timeScheduleSlice.selectors.addedServices],
  (addedServices) => {
    return Object.values(addedServices).reduce<number>((acc, addedService) => {
      return acc + addedService.bought
    }, 0)
  }
)
